<template>
  <div :class="{ 'gesture-button': true, 'encrypted': isEncrypted }" v-loading="loading" >
    <span v-if="isEncrypted" style="display: inline-flex;">{{ encryptedText }}
      <img @click="toggleEncryption" src="@/assets/new-image/header/隐藏.svg" alt="" v-if="isNeed">
    </span>
    <span v-else style="display: inline-flex;">{{ decryptedText }}
      <img @click="toggleEncryptionClose" src="@/assets/new-image/header/展开.svg" alt="">
    </span>
  </div>
</template>

<script>
import { decrypt } from "@/api/header/cursorPointer";
export default {
  props: {
    text: {
      type: String ,
      required: true
    },
    isNeed:{
      type: Boolean,
      default: true,
    },
    decryptText:{
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isEncrypted: true,
      decryptedText:'',
      loading: false,
    };
  },
  computed: {
    encryptedText() {
      if(this.text){
        let end = ""

        if(this.text.length > 6 ){
          end = this.text.slice(7)
          return this.text.substring(0,3) + '****' + end;
        }else{
          if(this.text.length > 2) end = this.text.charAt(this.text.length - 1)
          return this.text.charAt(0) + '**' + end;
        }

      }else{
        return ""
      }   
    },
    decryptText2(){
      return this.decryptText;
    }
  },
  methods: {
    toggleEncryptionClose() {
      this.isEncrypted = !this.isEncrypted;
    },
    toggleEncryption(){
      this.loading = true ;
      if( this.decryptText2 ){
        decrypt({ content: this.decryptText2 }).then((res) => {
          if (res.code == 200) {
            this.decryptedText = res.data
            this.loading = false;
          }
        });
      }else{
        this.decryptedText = this.text;
        this.loading = false;
      }
      this.isEncrypted = !this.isEncrypted;
    }
  }
};
</script>

<style scoped>
.gesture-button {
  display: inline-block;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
}

.gesture-button:hover {
  /* background-color: #f0f0f0; */
}

.encrypted {
  /* font-style: italic; */
  /* color: #999; */
}
</style>
